// apps/web/src/data/api-client.ts
// Typed fetch wrapper for api-worker endpoints. Per Plan §4.6.8 pattern.
//
// Per Step 22.A Q1 lock: absolute URL via VITE_API_URL + CORS (NOT
// same-origin via Pages _routes.json). credentials:'include' carries
// the HS256 session cookie minted by api-worker per Plan §4.7.10 L-9.

// Empty default = relative path = same-origin via Pages Function proxy
// (Step 22.E-prime-2 2026-05-18). Set VITE_API_URL only for non-default
// hosts (e.g., pointing local dev at a remote api-worker).
const API_BASE = import.meta.env.VITE_API_URL ?? '';

export class ApiError extends Error {
  override readonly name = 'ApiError';
  constructor(readonly status: number, readonly body: string) {
    super(`API ${status}: ${body.slice(0, 200)}`);
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: 'include',
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new ApiError(res.status, body);
  }
  return res.json() as Promise<T>;
}
